export default __webpack_public_path__ + "static/media/b3.12a7abdc.jpeg";